var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvalidOptions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.77 13.26C13.77 13.26 57.86 11.84 65.74 13.26C65.74 13.26 67.45 80.98 65.74 82.44C65.74 82.44 19.94 83.65 13.77 82.44C10.31 81.76 13.77 13.26 13.77 13.26Z",
    fill: "#FEDC5D",
    stroke: "#FEDC5D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5801 31.79V24.17C19.5801 23.73 20.0301 23.38 20.5801 23.38H30.7001C31.2501 23.38 31.7001 23.73 31.7001 24.17V31.79C31.7001 32.23 31.2501 32.58 30.7001 32.58H20.5801C20.0301 32.58 19.5801 32.23 19.5801 31.79Z",
    stroke: "#E0BF53",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5801 48.74V41.12C19.5801 40.68 20.0301 40.33 20.5801 40.33H30.7001C31.2501 40.33 31.7001 40.68 31.7001 41.12V48.74C31.7001 49.18 31.2501 49.53 30.7001 49.53H20.5801C20.0301 49.53 19.5801 49.18 19.5801 48.74Z",
    stroke: "#E0BF53",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5801 65.69V58.07C19.5801 57.63 20.0301 57.28 20.5801 57.28H30.7001C31.2501 57.28 31.7001 57.63 31.7001 58.07V65.69C31.7001 66.13 31.2501 66.48 30.7001 66.48H20.5801C20.0301 66.48 19.5801 66.13 19.5801 65.69Z",
    stroke: "#E0BF53",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1201 64.95H59.9201",
    stroke: "#E0BF53",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1201 31.4301H59.9201",
    stroke: "#E0BF53",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1201 25.66H59.9201",
    stroke: "#E0BF53",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1201 48.1901H59.9201",
    stroke: "#E0BF53",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1201 42.42H59.9201",
    stroke: "#E0BF53",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1201 59.1801H59.9201",
    stroke: "#E0BF53",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7601 67.19C87.7601 63.82 86.8801 61.1599 86.1601 59.5999C84.1801 55.0199 80.5001 51.3499 75.9101 49.3499C75.8901 49.3299 75.8601 49.3099 75.8201 49.2999C67.3201 45.4899 58.1501 48.01 52.9201 54.58H52.9401C49.9601 58.08 48.1601 62.6399 48.1801 67.6299C48.1901 70.3799 48.7601 72.9799 49.7701 75.3499C49.8001 75.4499 49.8401 75.5399 49.8801 75.6399C50.8201 77.9099 52.0401 79.4799 52.9501 80.4199C54.3801 82.0699 56.0801 83.4799 57.9901 84.5899C61.7501 86.9799 65.9201 87.8399 70.4401 87.1399C73.3801 86.7899 76.1201 85.7899 78.5101 84.2799C81.8201 82.3099 84.2901 79.5 85.8701 75.93C87.1001 73.3 87.7801 70.34 87.7601 67.22V67.1999V67.19Z",
    fill: "#FF4F40",
    stroke: "#FF4F40",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5701 74.6001L69.4401 53.5901C68.7901 52.4601 67.1601 52.4601 66.5001 53.5901L54.3701 74.6001C53.7201 75.7301 54.5301 77.1401 55.8401 77.1401H80.1001C81.4101 77.1401 82.2201 75.7301 81.5701 74.6001Z",
    fill: "white",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4601 71.1C66.5401 70.9 66.6601 70.72 66.8101 70.57C66.9601 70.42 67.1301 70.31 67.3401 70.22C67.5401 70.14 67.7601 70.09 67.9801 70.09C68.2001 70.09 68.4201 70.13 68.6201 70.22C68.8201 70.31 69.0001 70.42 69.1501 70.57C69.3001 70.72 69.4101 70.89 69.5001 71.1C69.5801 71.3 69.6201 71.52 69.6201 71.74C69.6201 71.96 69.5801 72.18 69.5001 72.38C69.4201 72.58 69.3001 72.76 69.1501 72.91C69.0001 73.06 68.8201 73.17 68.6201 73.26C68.4201 73.34 68.2001 73.38 67.9801 73.38C67.7601 73.38 67.5401 73.34 67.3401 73.26C67.1401 73.18 66.9601 73.06 66.8101 72.91C66.6601 72.76 66.5501 72.59 66.4601 72.38C66.3801 72.18 66.3301 71.96 66.3301 71.74C66.3301 71.52 66.3701 71.3 66.4601 71.1ZM69.5701 60.41L69.0901 68.37H66.8401L66.3601 60.41H69.5701Z",
    fill: "#FF4F40",
    stroke: "#FF4F40",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M22.71 31L28.35 25.36",
    stroke: "#E0BF53",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M22.71 25.36L28.35 31",
    stroke: "#E0BF53",
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M22.71 48L28.35 42.36",
    stroke: "#E0BF53",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M22.71 42.36L28.35 48",
    stroke: "#E0BF53",
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M22.71 64.5899L28.35 58.95",
    stroke: "#E0BF53",
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M22.71 58.95L28.35 64.5899",
    stroke: "#E0BF53",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvalidOptions);
export default __webpack_public_path__ + "static/media/invalid-options.ac48686f0cc003e1116bc3b2b558f381.svg";
export { ForwardRef as ReactComponent };